import React from 'react';
import { Alert } from 'antd';
import { AlertBarProps } from '../../interfaces/alert';
import './AlertBar.less';

const AlertBar: React.FC<AlertBarProps> = ({ message, type }) => (
  <Alert className="alert-wrap" message={message} type={type} showIcon />
);
export default AlertBar;
